/* eslint-disable no-unused-vars */
import store from "@/store";

/*
  Ação de clique nas ordens do gantt
  precisa ser usado mousedown e mouseup
  para verificar o tempo que o mouse fica pressionado
  pois se ficar muito tempo pressionado então ação não será
  executada pois está acontecendo arraste e não clique
*/
function clickAction(el, _data) {
  let clickStart;
  function mousedown(event) {
    clickStart = event.timeStamp;
  }

  function mouseUp(event) {
    const timeDiff = event.timeStamp - clickStart;
    if (timeDiff > 200) return;
    const operacao = event.target.textContent.replace(/^\s+|\s+$/g, "");
    if (!operacao) return;
    store.commit("changeRightSheetOp", { operacao, sequenciada: true });
  }

  el.addEventListener("mousedown", mousedown);
  el.addEventListener("mouseup", mouseUp);

  return {
    update(_, newData) {
      _data = newData;
    },
    destroy(el) {
      el.removeEventListener("mousedown", mousedown);
      el.removeEventListener("mouseup", mouseUp);
    },
  };
}

export default [clickAction];
